let SERVICE_CODE = {
    OSS_SIGNATURE: '0900001',
    LOGIN: '10100000', // 用户登录
    QUERY_PROCESS_INFO: '2020006', // 查询流程信息
    QUERY_NEWS_INFO: '2020007', // 查询新闻信息
    QUERY_SINGLE_SETTING: '2021001', // 查询个人应用及模式
    QUERY_USER_OWER_SETTING: '2021002', // 配置个人应用及模式
    QUERY_PROCESS_NUM: '2021003', // 流程数量
    QUERY_PROCESS_LIST: '2021004', // 流程列表
};

let STATE_CODE = {
    CORRECT_CODE: '0000', // 正确码
    CORRECT_CODE_REG: /^[M]/, // 其它状态正确码 以M字母开头的状态信息
    ERROR_CODE: /^(9901|9902|9903|9999)$/, // 错误码 9901,9902,9903,9999 系统错误
    SESSION_TIMEOUT_CODE: '9801', // session超时状态码
    RIGHT_LIMITE_CODE: '9803', // 没有权限执行该操作
    HAS_LOGIN_CODE: '9804' // 单点登录报错
}

export {
    SERVICE_CODE,
    STATE_CODE
};


// WEBPACK FOOTER //
// ./src/config/interface.js